import apiClient from "./axios-client";

/**
 * Get Bill Receipt Potkird Report
 * @returns
 */
export const getBillReceiptPotkirdReport = async (body) => {
  const response = await apiClient.post(`receipt/bill-receipt-potkird`, body);
  return response.data;
};

/**
 * Get General Receipt Potkird Report
 * @returns
 */
export const getGeneralReceiptPotkirdReport = async (body) => {
  const response = await apiClient.post(
    `receipt/general-receipt-potkird`,
    body
  );
  return response.data;
};
